export function createColOrderLinks (useText = true) {
  return {
    isLink: true,
    routerData: {
      pageName: 'OrderDetails',
      dataKey: 'account_number',
      textLink: useText ? 'заказ' : ''
    }
  }
}

export function createColAccountNumberLinks () {
  return {
    isLink: true,
    routerData: {
      pageName: 'OrderDetails',
      dataKey: 'account_number',
      dataKeySecond: 'position_sort',
      textLink: 'счёт №',
      textLinkSecond: 'позиция №',
      paramsKey: 'id',
      paramsValueKey: 'order_id'
    }
  }
}

export function createColReclamationLinks () {
  return {
    isLink: true,
    routerData: {
      pageName: 'ReclamationDetailsPage',
      dataKey: 'account_number',
      textLink: 'рекламация'
    }
  }
}

export function createColConsignmentLinks (useText = true, paramsValueKey = 'consignment_id', dataKey = 'consignment_text') {
  return {
    isLink: true,
    routerData: {
      pageName: 'DetailedConsignment',
      dataKey: dataKey,
      textLink: useText ? 'Партия №' : null,
      paramsKey: 'id_cons',
      paramsValueKey: paramsValueKey
    }
  }
}
